// extracted by mini-css-extract-plugin
module.exports = {"container":"playerNewsCard_container__tvVfD","text":"playerNewsCard_text__dWl0l","title":"playerNewsCard_title__4zLdS","avatar":"playerNewsCard_avatar__wVSaN"};